import Spinner from 'components/common/spinner';
import { whiteText } from 'components/common/colorConstants';
import { LoaderWrapper, LoadingText } from './BusyOverlay.styles';

/**
 * Simple overlay to display busy|loading activity on top of the Dialog contents.
 */
export default function BotDialogBusyOverlay() {
  return (
    <LoaderWrapper>
      <Spinner color={whiteText} size={26} />
      <LoadingText children={'Please wait...'} />
    </LoaderWrapper>
  );
}
